import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'; // 导入路由配置文件
import store from './store'; // 引入 Vuex store
import './assets/styles/custom-element-styles.css';
import './assets/styles/font-global.css';


Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  router,
  store, // 注入 Vuex store
  render: h => h(App),
}).$mount('#app')
